<template>
  <create-dialog
    width="60%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.company') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businessesInitial"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group has-label">
            <label class="d-flex">{{ $t('leaf.add_or_remove_leaf') }}:</label>
            <div class="row mt-2">
              <el-button
                v-tooltip.top-center="$t('common_words.add_task')"
                class="btn-success btn-secondary button-new-tag"
                size="small"
                @click="addLeaf()"
                icon="el-icon-plus"
              >
              </el-button>
              <el-button
                :disabled="model.leaf_count > minInputs ? false : true"
                v-tooltip.top-center="{
                  content: `
                      <div>
                        <strong>${$t('common_words.delete_task')}</strong><br>
                        ${
                          model.leaf_count === minInputs
                            ? '<small>' +
                              $t('leaf.cant_remove_existing_leaves') +
                              '</small>'
                            : ''
                        }
                      </div>
                    `,
                  html: true,
                }"
                class="btn-danger btn-secondary button-new-tag"
                size="small"
                @click="minusLeaf()"
                icon="el-icon-minus"
              >
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row py-2 mb-3 shadow-sm">
        <div
          v-for="index in model.leaf_count"
          :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`"
          :key="index"
        >
          <div class="d-flex align-items-center">
            <fg-input
              class="col-10 px-2"
              :label="`${$t('leaf.leaf_number')}: *`"
              :requiered="true"
              ref="name"
              type="text"
              v-model="model.name[index - 1]"
              :name="`leaf.leaf_number_${index}`"
              v-validate="modelValidations.name"
              :error="getFieldErrorByIndex('leaf.leaf_number', true, index)"
              :placeholder="`${$t('leaf.leaf_number')}`"
              :disabled="model.deleted_at[index - 1] ? true : false"
            >
            </fg-input>
            <div v-if="isDelete() && is_Update">
              <a
                :class="`${
                  model.deleted_at[index - 1] ? `my_success` : `my_danger`
                } btn-simple custom-margin-actions mt-3`"
                v-tooltip.top-center="
                  getTextTooltipDelete(model.deleted_at[index - 1])
                "
                v-model="model.deleted_at[index - 1]"
                ref="deleted_at"
                @click="
                  model.deleted_at[index - 1]
                    ? handleActivate(
                        `diseases/evaluationleafdetail/activatedetail`,
                        model.details_ids[index - 1],
                        index - 1
                      )
                    : handleDelete(
                        `diseases/evaluationleafdetail`,
                        model.details_ids[index - 1],
                        index - 1
                      )
                "
              >
                <em
                  :class="`fa ${
                    model.deleted_at[index - 1] ? `fa-check-circle` : `fa-times`
                  } custom-size-fa-actions`"
                ></em>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, convertFirstLetterUppercase } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import MixinRerender from 'src/mixins/mixin-rerender';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
    MixinRerender,
  ],
  data() {
    return {
      is_Update: false,
      disabledField: false,
      businessesInitial: [],
      model: {
        id: null,
        name: [],
        business_id: null,
        business_name: null,
        details_ids: [],
        evaluation_leaf_header_id: null,
        leaf_count: 1,
        deleted_at: [],
      },
      names: [],
      business_id: null,
      modelValidations: {
        name: { required: true },
      },
      minInputs: 1,
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          }
          if (this.is_Update) {
            for (let i = 0; i < this.names.length; i++) {
              if (
                this.names[i] !== this.model.name[i] ||
                this.model.name.length !== this.names.length ||
                this.business_id !== this.model.business_id
              ) {
                SweetAlert.confirm(
                  this.$t('common_words.confirm'),
                  this.$t('leaf.confirm_edit_evaluation_leaf')
                ).then((result) => {
                  if (result.value) {
                    let index = 0;
                    this.model.name.forEach((name) => {
                      this.model.name[index] =
                        convertFirstLetterUppercase(name);
                      index++;
                    });
                    this.$emit('addEdit', this.model);
                    return;
                  }
                });
              } else {
                let index = 0;
                this.model.name.forEach((name) => {
                  this.model.names[index] = convertFirstLetterUppercase(name);
                  index++;
                });
                this.$emit('addEdit', this.model);
                return;
              }
            }
          } else {
            let index = 0;
            this.model.name.forEach((name) => {
              this.model.names[index] = convertFirstLetterUppercase(name);
              index++;
            });
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'business_id', bsSelected);
      this.$set(this.model, 'business_names', data.names);
    },
    addLeaf() {
      this.model.leaf_count++;
    },
    minusLeaf() {
      if (this.model.leaf_count > 1) this.model.leaf_count--;
    },
    handleDelete(route, id, index) {
      if (isset(id)) {
        const data = {
          route: route,
          id: id,
        };
        SweetAlert.confirm(
          this.$t('common_words.confirm'),
          this.$t('leaf.confirm_disable_evaluation_leaf')
        ).then((result) => {
          if (result.value) {
            Promise.all([Axios.destroyMaster(data)]).then(
              ([responseDetail]) => {
                this.$emit('refresh', true);
                const { evaluation_leaf_details } = responseDetail.data.data;
                const detail = evaluation_leaf_details.filter((detail) => {
                  return detail.id == id;
                });
                this.$set(this.model.deleted_at, index, detail[0].deleted_at);
              }
            );
          }
        });
      }
    },
    handleActivate(route, id, index) {
      if (isset(id) && this.isDelete()) {
        const data = {
          route: route,
          id: id,
        };
        SweetAlert.confirm(
          this.$t('common_words.confirm'),
          this.$t('leaf.confirm_activate_evaluation_leaf')
        ).then((result) => {
          if (result.value) {
            Promise.all([Axios.updateMaster(data)]).then(([responseDetail]) => {
              this.$emit('refresh', true);
              const { evaluation_leaf_details } = responseDetail.data.data;
              const detail = evaluation_leaf_details.filter((detail) => {
                return detail.id == id;
              });
              this.$set(this.model.deleted_at, index, detail[0].deleted_at);
            });
          }
        });
      }
    },
    getTextTooltipDelete(deleted_at) {
      if (deleted_at) return i18n.t('common_words.activate');
      else return i18n.t('common_words.disable');
    },
  },
  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('businesses/only')])
        .then(([responseBusinesses]) => {
          this.businessesInitial = responseBusinesses.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, business_id, business, evaluation_leaf_details } = editForm;
      this.business_id = business_id;
      this.model = {
        ...this.model,
        id,
        business_id,
        business_name: business.name,
        isEdit: true,
      };
      this.model.leaf_count = evaluation_leaf_details.length;
      let indexDetail = 0;
      evaluation_leaf_details.forEach((detail) => {
        this.model.name.push(detail.name);
        this.names.push(detail.name);
        this.model.details_ids.push(detail.id);
        this.model.evaluation_leaf_header_id = detail.evaluation_leaf_header_id;
        this.$set(this.model.deleted_at, indexDetail, detail.deleted_at);
        indexDetail++;
      });
      sessionStorage.removeItem('editForm');
      this.is_Update = true;
      this.minInputs = this.model.leaf_count;
    }
  },
};
</script>
<style scoped>
.my_danger {
  color: #c63d2f !important;
}
.my_success {
  color: #4f8949 !important;
}
.my_danger:hover {
  cursor: pointer;
}
.my_success:hover {
  cursor: pointer;
}
</style>
